import { Badge, Tooltip } from '@chakra-ui/react';

const TxTypesAbbreviations = {
  1: 'ВвЭ',
  2: 'Прм',
  3: 'Уст',
  4: 'Снт',
  5: 'Крк',
  6: 'Спс',
};
const TxTypesColors = {
  1: 'teal',
  2: 'brand',
  3: 'pink',
  4: 'blue',
  5: 'orange',
  6: 'purple',
};

export const  TxTypeView = ({ type, full, size = 'sm' }: { type?: EntityBase, full?: boolean, size?: 'sm' | 'md' }) => {
  if (!type) {return <></>;}
  return <Tooltip label={type?.name || ''}>
    <Badge 
      cursor='default' 
      colorScheme={TxTypesColors[type.id]} 
      fontSize={10}
      px={size === 'md' ? 3 : 1}
      py={size === 'md' ? 2 : 0}
    >
      {full ? type.name : TxTypesAbbreviations[type.id]}
    </Badge>
  </Tooltip>;
};